export class StateMachine<TStatus extends string> {
  private readonly transitionsMap: ReadonlyMap<TStatus, readonly TStatus[]>;
  private readonly terminalStatuses: readonly TStatus[];

  constructor(
    transitions: ReadonlyArray<readonly [TStatus, readonly TStatus[]]>,
    terminalStatuses: readonly TStatus[],
  ) {
    this.transitionsMap = new Map(transitions);
    this.terminalStatuses = terminalStatuses;
  }

  isTerminal(status: TStatus): boolean {
    return this.terminalStatuses.includes(status);
  }

  isValidTransition(from: TStatus, to: TStatus): boolean {
    // Cannot transition to same status
    if (from === to) {
      return false;
    }

    const validNextStatuses = this.transitionsMap.get(from);
    return validNextStatuses !== undefined && validNextStatuses.includes(to);
  }

  getValidNextStatuses(current: TStatus): readonly TStatus[] {
    return this.transitionsMap.get(current) ?? [];
  }
}
